import { getForms } from '@api/formsApi';
import { useQuery } from 'api-hooks/hooks';
import { Box } from '@components';
import { FormModel } from '@models/form-model';
import { Table } from 'antd';
import React from 'react';
import DateView from '@components/date-view/DateView';

type Props = {
  customerId: number;
  editable?: boolean;
  onSelect?: (form: FormModel) => any;
  onEdit?: (form: FormModel) => any;
};

const FormList: React.FC<Props> = ({
  customerId,
  editable = true,
  onEdit = () => {},
  onSelect = () => {}
}) => {
  const { data: forms, loading } = useQuery(getForms(customerId));

  const columns = [
    { title: 'Form name', dataIndex: 'name' },
    {
      title: 'Last update',
      dataIndex: 'modified_at',
      render: (date: string) => <DateView date={date} />
    },
    {
      title: 'Action',
      key: 'actions',
      render: (v, row, index) => (
        <span className="font-normal">
          <span
            className="text-secondary cursor-pointer"
            onClick={() => onSelect(row)}
          >
            Preview
          </span>
          {editable && (
            <>
              &nbsp;|&nbsp;
              <span
                className="text-primary cursor-pointer"
                onClick={() => onEdit(row)}
              >
                Edit
              </span>
            </>
          )}
        </span>
      )
    }
  ];

  return (
    <Box
      header="Form Selection"
      content={
        <Table
          bordered={true}
          columns={columns}
          dataSource={forms}
          rowKey="id"
          loading={loading}
        />
      }
    />
  );
};

export default FormList;
